import { Grid } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import TextField from '../../../components/Form/TextField'
import { useStyles } from '../Style'
import Date from "../../../components/Form/Date"
import { useForm } from 'react-hook-form'

type props = any;

interface IFormInput {
    mvmNumber: string;
    supplier: string;
    shippingCompanySupplier: string;
    vehiclePlateNumber: string;
    shed: string;
    createdAt: Date | null;
    invoiceKey: string;
    invoiceNumber: string;
    cfop: string;
    requestNumber: string;
    sentDate: Date | null;
    status: string;
    requestBaseId: string;
    supplierSapCode: string;
    shippingCompanySapCode: string;
    plantCode: string;
    createdBy: string;
}

const MvmOutgoingRequestSummary: React.FC<props> = ({ mvmOutgoingInvoiceRequest }) => {
    const classes = useStyles()
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tGeneral } = useTranslation("General")

    const { control,  setValue } = useForm<IFormInput>(
        {
            defaultValues: {     
                mvmNumber: '',
                supplier: '',
                shippingCompanySupplier: '',
                vehiclePlateNumber: '',
                shed: '',
                createdAt: null,
                invoiceKey: '',
                invoiceNumber: '',
                cfop: '',
                requestNumber: '',
                sentDate: null,
                status: '',
                requestBaseId: '',
                supplierSapCode: '',
                shippingCompanySapCode: '',
                plantCode: '',
                createdBy: '',
             }
        })

    useEffect(() => {

        if (!mvmOutgoingInvoiceRequest)
         return

        setValue('mvmNumber', mvmOutgoingInvoiceRequest.mvmNumber)
        setValue('supplier', mvmOutgoingInvoiceRequest.supplierId + " - " + mvmOutgoingInvoiceRequest.supplierCorporateName)
        setValue('shippingCompanySupplier',mvmOutgoingInvoiceRequest.shippingCompanyId + " - " + mvmOutgoingInvoiceRequest.shippingCompanyCorporateName)
        setValue('vehiclePlateNumber', mvmOutgoingInvoiceRequest.vehiclePlateNumber)
        setValue('shed', mvmOutgoingInvoiceRequest.shedCode)
        setValue('plantCode', mvmOutgoingInvoiceRequest.codPlant)
        setValue('supplierSapCode', mvmOutgoingInvoiceRequest.supplierSapCode)
        setValue('shippingCompanySapCode', mvmOutgoingInvoiceRequest.shippingCompanySapCode)
        setValue('createdAt', mvmOutgoingInvoiceRequest.createdAt)
        setValue('createdBy', mvmOutgoingInvoiceRequest.createdBy)
        setValue('invoiceKey', mvmOutgoingInvoiceRequest.invoiceKey)
        setValue('invoiceNumber', mvmOutgoingInvoiceRequest.invoiceNumber)
        setValue('cfop', mvmOutgoingInvoiceRequest.cfop)
        setValue('requestNumber', mvmOutgoingInvoiceRequest.requestNumber)
        setValue('sentDate', mvmOutgoingInvoiceRequest.sentDate)
        setValue('status', mvmOutgoingInvoiceRequest.statusDescription)
        setValue('requestBaseId', mvmOutgoingInvoiceRequest.requestBaseId)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mvmOutgoingInvoiceRequest])

    return (
        <form >
            <Grid style={{ marginTop: 20, width: "98%", marginBottom: 10 }}>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("mvmNumber")} 
                            name="mvmNumber" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>                                
                    </Grid>
                    <Grid item xs={4}>
                        <TextField 
                            label={tMvm("supplier")} 
                            name="supplier" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>                                 
                    </Grid> 
                    <Grid item xs={4}>
                        <TextField 
                            label={tMvm("shippingCompanySupplier")} 
                            name="shippingCompanySupplier" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>                                 
                    </Grid> 
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("vehiclePlateNumber")} 
                            name="vehiclePlateNumber" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("shed")} 
                            name="shed" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("plantCode")} 
                            name="plantCode" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>                                 
                    </Grid> 
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("supplierSapCode")} 
                            name="supplierSapCode" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>                                 
                    </Grid> 
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("shippingCompanySapCode")} 
                            name="shippingCompanySapCode" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>                                 
                    </Grid> 
                    <Grid item xs={2}>
                        <Date 
                            label={tMvm("createdAt")} 
                            name="createdAt" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            disable={true} />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            label={tGeneral("createdBy")} 
                            name="createdBy" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Date 
                            label={tMvm("sentDate")} 
                            name="sentDate" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            disable={true}/>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("requestNumber")} 
                            name="requestNumber" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                    
                    <Grid item xs={4}>
                        <TextField 
                            label={tMvm("invoiceKey")} 
                            name="invoiceKey" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("invoiceNumber")} 
                            name="invoiceNumber" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            label={"CFOP"} 
                            name="cfop" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/>  
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <TextField 
                            label={tMvm("status")} 
                            name="status" 
                            control={control} 
                            fullWidth
                            InputLabelProps={{shrink:true}}
                            InputProps={{
                                readOnly: true,
                                classes: {
                                    input: classes.inputBlocked
                                }
                            }}/> 
                    </Grid>
                    {mvmOutgoingInvoiceRequest && mvmOutgoingInvoiceRequest.requestBaseId && 
                        <Grid item xs={2}>
                            <TextField 
                                label={tMvm("requestBaseId")} 
                                name="requestBaseId" 
                                control={control} 
                                fullWidth
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>
                    }
                    
                    
                    
                </Grid>
            </Grid>
        </form>
    )
}

export default MvmOutgoingRequestSummary

